import React from 'react';

const SourceBreakdownPanel = ({ title, icon: Icon, iconTint, badgeTint, rows }) => (
  <div className="bg-white rounded-xl p-6 border border-slate-200">
    <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2">
      <Icon className={`w-4 h-4 text-${iconTint}-600`} />
      {title}
    </h3>
    <div className="space-y-2">
      {rows.map((row) => (
        <div key={row.source} className="flex items-center justify-between text-sm">
          <span className="font-mono text-slate-700">{row.source}</span>
          <span className={`px-2 py-0.5 bg-${badgeTint}-100 text-${badgeTint}-700 rounded-full font-semibold`}>
            {row.count}
          </span>
        </div>
      ))}
      {rows.length === 0 && (
        <p className="text-sm text-slate-500">No leads yet</p>
      )}
    </div>
  </div>
);

export default SourceBreakdownPanel;
